import { makeStyles } from '@material-ui/core/styles'
import { Button, FormControl, TextField } from '@mui/material'
import EnquireNowDiscount from 'src/assets/AddedServices/EnquireNowDiscount.svg'
import EnquireNowCarImage from 'src/assets/AddedServices/EnquireNowCarImage.svg'
import { NAME_REGEX, PHONE_REGEX } from 'src/utils/constants/BuyPolicyMotor'
import { useFormik } from 'formik'
import { useMutation } from '@apollo/client'
import * as Yup from 'yup'
import {
  getFormControlErrorText,
  isFormControlError,
} from 'src/services/formHelperService'
import { COLORS } from 'src/utils/Themes/colors'
import {
  CONTACT_FORM_ERROR_MESSAGES,
  DashboardEmailsEnums,
} from 'src/utils/constants/ValueAddedServicesData'
import { useDispatch, useSelector } from 'react-redux'
import { RAISE_REQUEST } from 'src/services/individualService'
import { showNotificationMessage } from 'src/actions'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import React from 'react'
import LoadingModal from 'src/components/common/LoadingModal'
import {
  NEW_VEHICLE_ENQUIRY,
  NOTIFICATION_SETTINGS_MSG,
} from 'src/utils/constants/Individual'

const EnquireNow = () => {
  const classes = useStyles()
  const { loggedInUserInfo } = useSelector((state) => {
    return {
      loggedInUserInfo: state?.userInfo,
    }
  })
  const dispatch = useDispatch()
  const initialValues = {
    name: '',
    phone: '',
    make: '',
    modal: '',
    date: '',
    vehicleDetails: '',
  }

  const contactForm = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      name: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.NAME_REQUIRED)
        .matches(NAME_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_NAME),
      phone: Yup.string()
        .required(CONTACT_FORM_ERROR_MESSAGES?.PHONE_REQUIRED)
        .matches(PHONE_REGEX, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .max(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE)
        .min(10, CONTACT_FORM_ERROR_MESSAGES?.VALID_PHONE),
      vehicleDetails: Yup.string().required(
        CONTACT_FORM_ERROR_MESSAGES?.VEHICLE_DETAILS_REQUIRED
      ),
    }),
    onSubmit: (values, { setSubmitting }) => {
      handleSubmit(values)
      setSubmitting(true)
    },
    enableReinitialize: true,
  })

  const handleSubmit = (values) => {
    raiseRequest({
      variables: {
        emailsDetails: {
          emailType: DashboardEmailsEnums?.NEW_CAR_ENQUIRY,
          name: values?.name,
          phoneNumber: values?.phone,
          email: loggedInUserInfo?.userInfo?.userData?.emailId,
          vehicleDetails: values?.vehicleDetails,
        },
      },
    })
  }

  const [raiseRequest, { loading }] = useMutation(RAISE_REQUEST(), {
    onCompleted: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.SUCCESS,
          message: NEW_VEHICLE_ENQUIRY,
        })
      )
      contactForm.resetForm({
        ...initialValues,
      })
    },
    onError: () => {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_SETTINGS_MSG?.ENCOUNTERED_ERROR_ON_REQUEST_RAISED,
        })
      )
    },
  })

  return (
    <>
      <LoadingModal loading={loading} />
      <div className={classes.container}>
        {/* <CloseIcon id='closeIcon' className={classes.closeIcon} onClick={closefunction} /> */}
        <div className={classes.mainContainer}>
          <div className={classes.discountImageContainer}>
            <div className={classes.discountContainer}>
              <img
                src={EnquireNowDiscount}
                alt='EnquireNowDiscount'
                className={classes.discountImage}
              />
            </div>
            <div className={classes.insuranceText}>
              <span>
                Your exclusive<br></br>Insurance<br></br>
                <span className={classes.insuranceTextHeading}>
                  Discount<br></br>Awaits
                </span>
              </span>
            </div>
          </div>
          <div className={classes.detailsContainer}>
            <form>
              <div className={classes.detailsHeading}>
                <span>Share your Details</span>
              </div>
              <div className={classes.input}>
                <FormControl>
                  <TextField
                    id='name'
                    name='name'
                    placeholder=' Name'
                    size='small'
                    fullWidth
                    className={classes.customTextField}
                    value={contactForm?.values?.name}
                    onChange={contactForm.handleChange}
                    onBlur={contactForm.handleBlur}
                    error={isFormControlError(contactForm, 'name')}
                    helperText={getFormControlErrorText(contactForm, 'name')}
                  />
                </FormControl>
              </div>
              <div className={classes.input}>
                <FormControl>
                  <TextField
                    id='phone'
                    name='phone'
                    type='number'
                    placeholder=' Phone'
                    size='small'
                    fullWidth
                    className={classes.customTextField}
                    value={contactForm?.values?.phone}
                    onChange={(event) => {
                      event.target.value = Math.max(
                        0,
                        parseInt(event?.target?.value)
                      )
                        ?.toString()
                        ?.slice(0, 10)
                      contactForm.setFieldValue(
                        'phone',
                        event?.target?.value,
                        false
                      )
                    }}
                    onBlur={contactForm.handleBlur}
                    error={isFormControlError(contactForm, 'phone')}
                    helperText={getFormControlErrorText(contactForm, 'phone')}
                  />
                </FormControl>
              </div>
              <div className={classes.input}>
                <FormControl>
                  <TextField
                    id='vehicleDetails'
                    name='vehicleDetails'
                    placeholder=" Tell us your car's make and model, and when you plan to buy"
                    size='small'
                    multiline
                    rows={4}
                    fullWidth
                    className={classes.customTextField}
                    value={contactForm?.values?.vehicleDetails}
                    onChange={contactForm.handleChange}
                    onBlur={contactForm.handleBlur}
                    error={isFormControlError(contactForm, 'vehicleDetails')}
                    helperText={getFormControlErrorText(
                      contactForm,
                      'vehicleDetails'
                    )}
                  />
                </FormControl>
              </div>
              <div className={classes.submitContainer}>
                <Button
                  className={classes.submit}
                  onClick={() => {
                    contactForm.submitForm()
                  }}
                >
                  Submit
                </Button>
              </div>
              <div className={classes.noteText}>
                <span>
                  * We promise: no more calls or messages... unless it&apos;s
                  about this incredible offer!
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  )
}

export default EnquireNow
const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    background: 'transparent',
  },
  mainContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    background: '#FFF',
    backgroundImage: `url(${EnquireNowCarImage})`,
    backgroundRepeat: 'no-repeat',
    height: '485px',
  },
  input: {
    paddingBottom: '10px',
  },
  discountImage: {
    width: '285px',
    marginTop: '-40px',
    '@media (max-width:1024px)': {
      width: '230px',
    },
  },
  submit: {
    border: '1px  solid #EF669B !important',
    borderRadius: '10px !important',
    cursor: 'pointer  !important',
    color: '#FFF !important',
    textTransform: 'unset !important',
    margin: 'unset',
    width: '90px !important',
    height: '2.2rem !important',
    fontSize: '15px !important',
    fontWeight: '500 !important',
    background:
      'linear-gradient(275.36deg, #B92351 -108.59%, #EF669B 227.07%) !important',
  },
  detailsHeading: {
    padding: '20px 0px',
    fontSize: '22px',
    fontWeight: '400',
  },
  detailsContainer: {
    padding: '50px 10px',
    width: '55%',
    textAlign: 'center',
  },
  submitContainer: {
    textAlign: 'center',
  },
  discountImageContainer: {
    width: '55%',
    textAlign: 'end',
  },
  insuranceText: {
    fontFamily: 'Montserrat',
    fontSize: '17',
    fontWeight: '700',
    zIndex: '1',
    position: 'absolute',
    paddingLeft: '205px',
    paddingTop: '55px',
    textAlign: 'center',
    '@media (max-width:1024px)': {
      paddingLeft: '155px',
      paddingTop: '40px',
    },
  },
  insuranceTextHeading: {
    fontFamily: 'Montserrat',
    fontSize: '26px',
    fontWeight: '800',
    color: '#B92351',
  },
  discountContainer: {
    position: 'absolute',
    zIndex: '0',
    paddingLeft: '115px',
    textAlign: 'end',
    '@media (max-width:1024px)': {
      paddingLeft: '90px',
    },
  },
  closeIcon: {
    marginLeft: '95%',
    marginTop: '1%',
    cursor: 'pointer',
    width: '20px',
    color: COLORS.MEDIUM_BLUE03,
  },
  noteText: {
    fontSize: '13px',
    fontWeight: '400',
    fontStyle: 'italic',
    color: '#717171',
    marginTop: '75px',
    '@media (max-width:1380px)': {
      padding: '10px 50px',
    },
  },
  customTextField: {
    justifyContent: 'center',
    '& .MuiInputBase-input': {
      WebkitTextFillColor: '#333333 !important',
    },
    '& .MuiInputBase-root': {
      borderRadius: '10px !important',
      width: '220px !important',
    },
    '&  .MuiOutlinedInput-input': {
      fontStyle: 'italic',
      fontSize: '13px',
      color: '#7C7C7C !important',
    },
  },
})
